import { Components, Theme } from '@mui/material/styles';

import { elevationLevel } from '../constants';

export const drawerConfigs: Components<Theme>['MuiDrawer'] = {
  defaultProps: {
    keepMounted: false,
    anchor: 'right',
    hideBackdrop: true,
    PaperProps: {
      elevation: elevationLevel.l,
    },
  },
  styleOverrides: {
    root: ({ theme }) => ({
      '.MuiDrawer-paper': {
        backgroundColor: theme.palette.background.paper,
        width: '100vw',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',

        [theme.breakpoints.up('lg')]: {
          backgroundColor: theme.palette.background.paper,
          borderTopLeftRadius: 32,
          borderBottomLeftRadius: 32,
          width: 552,
        },
      },
    }),
  },
};
